import { render, staticRenderFns } from "./CommonSetting.vue?vue&type=template&id=3e2f9afa&scoped=true&"
import script from "./CommonSetting.vue?vue&type=script&lang=ts&"
export * from "./CommonSetting.vue?vue&type=script&lang=ts&"
import style0 from "./CommonSetting.vue?vue&type=style&index=0&id=3e2f9afa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2f9afa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
